export const XS_MOBILE_MAX = 480;
export const MOBILE_MAX = 767;
export const TABLET_MIN = 768;
export const TABLET_MAX = 991;
export const DESKTOP_MIN = 992;
export const DESKTOP_MAX = 1999;
export const LG_DESKTOP_MIN = 1200;

const defaultOptions = {
  lowPixelDensitySuffix: '',
  ignoreScreenSize: false,
  ignorePixelDensity: false,
};

export function isXsMobile() {
  return window.matchMedia(`(max-width: ${XS_MOBILE_MAX}px)`).matches;
}

export function isMobile() {
  return window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches;
}

export function isTablet() {
  return window.matchMedia(`(min-width: ${TABLET_MIN}px) and (max-width: ${TABLET_MAX}px)`).matches;
}

export function isDesktop() {
  return window.matchMedia(`(min-width: ${DESKTOP_MIN}px)`).matches;
}

export function isLargeDesktop() {
  return window.matchMedia(`(min-width: ${LG_DESKTOP_MIN}px)`).matches;
}

export function notMobile() {
  return window.matchMedia(`(min-width: ${TABLET_MIN}px)`).matches;
}

export function notTablet() {
  return window.matchMedia(`(max-width: ${MOBILE_MAX}px), (min-width: ${DESKTOP_MIN}px)`).matches;
}

export function notDesktop() {
  return window.matchMedia(`(max-width: ${TABLET_MAX}px)`).matches;
}

export function notLargeDesktop() {
  return window.matchMedia(`(max-width: ${DESKTOP_MAX}px)`).matches;
}

export function isHighPixelDensity() {
  return window.matchMedia('(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)').matches;
}

function getOptions(options = defaultOptions) {
  return {
    lowPixelDensitySuffix:
      options.lowPixelDensitySuffix == null
        ? defaultOptions.lowPixelDensitySuffix
        : options.lowPixelDensitySuffix,
    ignoreScreenSize:
      options.ignoreScreenSize == null ? defaultOptions.ignoreScreenSize : options.ignoreScreenSize,
    ignorePixelDensity:
      options.ignorePixelDensity == null
        ? defaultOptions.ignorePixelDensity
        : options.ignorePixelDensity,
  };
}

export function getScreenSizeDescriptor(options) {
  const { ignoreScreenSize } = getOptions(options);

  if (ignoreScreenSize === true) return '';
  if (isMobile()) return 'Mobile';
  if (isTablet()) return 'Tablet';

  return 'Desktop';
}

export function getPixelDensityDescriptor(options) {
  const { ignorePixelDensity, lowPixelDensitySuffix } = getOptions(options);

  if (ignorePixelDensity === true) return '';
  if (isHighPixelDensity()) return '2X';

  return lowPixelDensitySuffix;
}

export function getAssetSource(assetKey, assetCollection, options, namespace = '') {
  const screenSize = getScreenSizeDescriptor(options);
  const pixelDensity = getPixelDensityDescriptor(options);
  try {
    return assetCollection(`${namespace}${assetKey}${screenSize}${pixelDensity}`);
  } catch (error) {
    return 'missing-img';
  }
}
